/**
 * File: search-bar.js
 *
 * Help deal with the search bar toggle.
 */

// Make sure everything is loaded first.
if (
	( 'complete' === document.readyState ||
		'loading' !== document.readyState ) &&
	! document.documentElement.doScroll
) {
	searchBarToggle();
} else {
	document.addEventListener( 'DOMContentLoaded', searchBarToggle );
}

/**
 * Kick off our off search toggle.
 *
 * @author Kelsey
 */
function searchBarToggle() {
	const searchBar = document.querySelector( '.search-bar' );
	if ( ! searchBar ) {
		return;
	}

	const searchContainer = document.querySelector( '.search-form-container' ),
		searchToggle = document.querySelector( '.search-button' ),
		searchClose = document.querySelector( '.search-close' );

	searchToggle.addEventListener( 'click', toggleSearch );
	searchClose.addEventListener( 'click', closeSearchToggle );
	document.body.addEventListener( 'keydown', closeOnEscape );

	/**
	 * Close everything when we hit the escape key.
	 *
	 * @author Corey Collins
	 * @since January 31, 2020
	 * @param {Object} event The event trigger.
	 */
	function closeOnEscape( event ) {
		if ( 27 === event.keyCode ) {
			closeSearchToggle();
		}
	}

	/**
	 * Handle closing the off-canvas overlay.
	 *
	 * @author Corey Collins
	 * @since January 31, 2020
	 */
	function closeSearchToggle() {
		searchContainer.classList.remove( 'is-visible' );
		searchToggle.classList.remove( 'is-visible' );

		searchContainer.setAttribute( 'aria-hidden', true );
		searchToggle.setAttribute( 'aria-expanded', false );
	}

	/**
	 * Toggle the display of the off-canvas overlay.
	 *
	 * @author Corey Collins
	 * @since January 31, 2020
	 */
	function toggleSearch() {
		if ( 'true' === searchToggle.getAttribute( 'aria-expanded' ) ) {
			closeSearchToggle();
		} else {
			openOffCanvas();
		}
	}

	/**
	 * Handle opening the off-canvas overlay.
	 *
	 * @author Corey Collins
	 * @since January 31, 2020
	 */
	function openOffCanvas() {
		searchContainer.classList.add( 'is-visible' );
		searchToggle.classList.add( 'is-visible' );

		searchContainer.setAttribute( 'aria-hidden', false );
		searchToggle.setAttribute( 'aria-expanded', true );
	}
}
